module.exports = __webpack_public_path__ + "static/img/advantage3.55a6e04a.png";